import { R } from '@core/utils/r';
import { WithTooltip } from '@modules/common';
import { CBody } from '@modules/common/CBody';
import { ReportBuilderFormData, ReportSummaryData } from '@modules/dynamicReports/ReportForms';
import React, { memo } from 'react';
import CountUp from 'react-countup';
import { Col, Row } from 'reactstrap';
export interface ReportSummaryItemProps {
  item: ReportSummaryData;
  value: number;
}

const ReportSummaryItem = memo((props: ReportSummaryItemProps) => {
  const { item, value } = props;
  return (
    <WithTooltip tooltip={item.description}>
      <div className="d-flex align-items-center justify-content-center flex-column">
        <span className="text-muted">{item.title}</span>
        <h5 className="mb-0 mt-1">
          <CountUp
            separator=","
            preserveValue
            end={value}
            duration={1}
            decimals={item.decimals}
            prefix={R.isEmpty(item.prefix) ? '' : item.prefix}
          ></CountUp>
        </h5>
      </div>
    </WithTooltip>
  );
});

export interface ReportSummaryProps {
  report: ReportBuilderFormData;
  results: number[];
}

export const ReportSummary = memo((props: ReportSummaryProps) => {
  const { report, results } = props;

  if (!report.summary.length) return null;
  return (
    <CBody>
      <Row>
        <Col style={{ display: 'grid', gridTemplateColumns: 'repeat( auto-fit, minmax(200px, 1fr) )', columnGap: '1rem' }}>
          {report.summary.map((item, index) => (
            <ReportSummaryItem item={item} key={index} value={R.get(results, index) || 0} />
          ))}
        </Col>
      </Row>
    </CBody>
  );
});
